/* @ngInject */
function CommentReactionItemController ($scope, $timeout, $attrs) {
  $scope.darkMode = $scope.darkMode || false

  $scope.initComponent = () => {
    $timeout(() => {
      $($attrs.$$element.find('.comment-reaction-item__container')[0]).popup({})
    }, 500, false)
  }

  $scope.getTextColor = () => {
    return $scope.darkMode ? 'neutralColorLowLight' : 'neutralColorLowPure'
  }
}

export { CommentReactionItemController }
